import { Message } from 'semantic-ui-react';

export const MaintenanceEmptyState = ({ loading }) => {
  if (loading) return null;

  return (
    <Message info>
      <Message.Header>No maintenance issues found</Message.Header>
      <p>
        There are currently no assets with problems marked as out of service or under maintenance in your accessible scope.
      </p>
    </Message>
  );
};

export default MaintenanceEmptyState;